// NotFound Component
import React from "react";
import { useHistory } from "react-router-dom";
import WhelenRImg from "../../assets/images/W-Red.svg";

const NotFound = () => {
  const history = useHistory();
  const getYear = () => new Date().getFullYear();
  const handleBack = () => {
    history.push("/home");
  };

  return (
    <>
      <div className="not-found-page theme-dark">
        <div className="not-found-wrapper fluid-wrapper ">
          <img alt="Whelen" src={WhelenRImg} className="logo mb-4 pb-3" />
          <h1 className="not-found-title">404</h1>
          <h4 className="not-found-message">The page you requested could not be found.</h4>
          <button type="button" className="back-button btn btn-primary" onClick={handleBack}>
            <i className="fa fa-arrow-left left-arrow-icon" />
            BACK TO HOME
          </button>
        </div>
        <div className="not-found-footer">
          <footer className="footer">
            <div className="container">
              <div className="text-center">
                Copyright &copy;
                {getYear()}
                <a href="https://www.whelen.com/" rel="noreferrer" target="_blank" className="d-inline-block mx-2">
                  Whelen Engineering.
                </a>
                All rights reserved.
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default NotFound;
